module.exports = (s) => {
  const role_list = ['admin', '管理员', '组长', '优化师'];
  const is_copy_url_button = role_list.includes(s.$store.getters.roles[0]);

  return [
    {
      name: 'ID',
      value: 'id',
      width: 80,
      align: 'center',
    },
    {
      name: '素材名称',
      value: 'name',
      width: 250,
      align: 'center',
      props: {
        sortable: 'custom',
      },
      format: (row, column, cell_value) => {
        return s.randerEditDom(row, cell_value, s.updateName, 'name');
      },
    },
    {
      name: '游戏',
      value: 'game',
      width: 150,
      align: 'center',
      format: (row, column, cell_value) => {
        return cell_value ? cell_value.name : '';
      },
    },
    {
      name: '作者',
      value: 'author',
      align: 'center',
      format: (row, column, cell_value) => {
        return cell_value ? cell_value.name : '';
      },
    },
    {
      name: '素材需求人',
      value: 'demand_sider',
      width: 200,
      align: 'center',
      format: (row, column, cell_value) => {
        return cell_value ? s.randerEditDom(row, cell_value, s.updateDemandSider, 'demand_sider_id') : '';
      },
    },
    {
      name: '是否原创',
      value: 'is_original',
      align: 'center',
      format: (row, column, cell_value) => {
        return cell_value ? '原创' : '非原创';
      },
    },
    {
      name: '素材类型',
      value: 'material_type',
      align: 'center',
      format: (row, column, cell_value) => {
        const type_obj = {
          '1': '图片',
          '2': '视频',
          '3': '落地页',
          '4': '组图',
        };
        return type_obj[cell_value];
      },
    },
    {
      name: '素材尺寸（宽高）',
      value: 'width',
      width: 125,
      align: 'center',
      format: (row, column, cell_value) => {
        return row.width + '*' + row.height;
      },
    },
    {
      name: '标签',
      value: 'material_labels',
      align: 'center',
      width: 300,
      format: (row) => {
        const h = s.$createElement;
        return h('div', { class: 'truncate' }, [
          h('i', {
            class: 'el-icon-edit-outline font-16 mr-10',
            on: {
              click: () => {
                s.onViewLocalMaterialLabels({ id: row.id, game: row.game });
              },
            },
          }),
          h('span', null, (row.material_labels || []).map(({ label }) => label).join('、')),
        ]);
      },
    },
    {
      name: '备注',
      value: 'note',
      width: 170,
      align: 'center',
      format: (row, column, cell_value) => {
        return s.randerEditDom(row, cell_value, s.updateNote, 'note');
      },
    },
    {
      name: '创建时间',
      value: 'created_at',
      width: 150,
      align: 'center',
      props: {
        sortable: 'custom',
      },
    },
    {
      name: '更新时间',
      value: 'updated_at',
      width: 150,
      align: 'center',
      props: {
        sortable: 'custom',
      },
    },
    {
      name: '预览',
      value: 'url',
      width: 150,
      fixed: 'right',
      align: 'center',
      format: (row, column, cell_value) => {
        const h = s.$createElement;
        const ele = h('div',
          null, [
            h('material-preview',
              {
                props: {
                  'materialType': row.material_type,
                  'material-list': row.url,
                },
              }, ''),
          ]);
        return ele;
      },
    },
    {
      name: '操作',
      value: 'id',
      width: is_copy_url_button ? 400 : 300,
      fixed: 'right',
      align: 'center',
      format: (row, column, cell_value) => {
        const h = s.$createElement;
        const ele = h('div',
          null, [
            h('el-button',
              {
                props: {
                  size: 'mini',
                  type: 'danger',
                },
                on: {
                  click: () => {
                    if (!row.can_delete){
                      this.$message.warning('当前无权限删除！');
                      return;
                    }
                    s.removeMaterial({
                      id: cell_value,
                    }).then((res) => {
                      s.$message({
                        message: res.message,
                        type: 'success',
                      });
                      s.$refs['my-table'].seekTable();
                    });
                  },
                },
              }, '删除'),
            h('el-button',
              {
                on: {
                  click: () => {
                    s.downloadMaterial({
                      id: cell_value,
                    }).then((res) => {
                      s.downloadZip(res, row.name);
                    });
                  },
                },
              }, '下载'),
            h('el-button',
              {
                on: {
                  click: () => {
                    s.edit_material.is_show = true;
                    s.edit_material.data = row;
                  },
                },
              }, '替换素材'),
            is_copy_url_button ? h('el-button',
              {
                on: {
                  click: () => {
                    // 在安全域下使用 navigator.clipboard 提升效率，非安全域退回到 document.execCommand('copy'); 保证功能一直可用。
                    if (navigator.clipboard && window.isSecureContext) {
                      navigator.clipboard.writeText(row.url[0]?.url).then(() => {
                        s.$message.success('链接已复制好，可贴粘');
                      }).catch(() => {
                        s.copyToClip(row.url[0]?.url);
                      });
                    } else {
                      s.copyToClip(row.url[0]?.url);
                    }
                  },
                },
              }, '复制素材链接') : '',
          ]);
        return ele;
      },
    },
  ];
};
